import React from "react";
import "./NumberDetail.css";

const NumberDetail = ({ text, label, border }) => {
    return (
        <div>
            <div className={`number-detail ${border ? "bordered" : ""}`}>
                <span className="label">{label}</span>
                <span className="number">{text?.toLocaleString()}</span>
                <span className="currency">ש"ח</span>
            </div>
        </div>
    );
};

export default NumberDetail;
